export default {
  // Pipe the VB processor inline into the local video track exactly once.
  //
  // When a user joins without blur, publishStreamToChannel creates plain
  // camera tracks and never wires the processor, so vbPipelined stays false.
  // Any later attempt to enable blur must first pipe the processor into the
  // track, otherwise vbProcessor.enable() runs on a processor that isn't
  // connected to the published track and viewers keep receiving raw video.
  //
  // Returns true when the processor is (now) piped and usable, false otherwise.
  ensureVbPipelined() {
    if (!this.vbProcessorReady || !this.vbProcessor) {
      return false;
    }

    if (this.vbPipelined) {
      return true;
    }

    if (!this.localVideoTrack) {
      return false;
    }

    this.localVideoTrack
      .pipe(this.vbProcessor)
      .pipe(this.localVideoTrack.processorDestination);
    this.vbPipelined = true;

    return true;
  }
};
